import { useState, useEffect, useCallback } from 'react';

const PREFIX = 'bnf_v1_';

function _storageKey(key) {
  return key.startsWith(PREFIX) ? key : PREFIX + key;
}

export function clearAllPersistedMapState() {
  const keys = [];
  for (let i = 0; i < localStorage.length; i++) {
    const k = localStorage.key(i);
    if (k && k.startsWith(PREFIX)) keys.push(k);
  }
  keys.forEach(k => localStorage.removeItem(k));
}

export function applyPendingClear() {
  if (sessionStorage.getItem('bnf_clear_on_load') === '1') {
    sessionStorage.removeItem('bnf_clear_on_load');
    clearAllPersistedMapState();
  }
}

function usePersistedState(key, defaultValue) {
  const sk = _storageKey(key);

  const [state, setState] = useState(() => {
    try {
      const saved = localStorage.getItem(sk);
      if (saved !== null) {
        const parsed = JSON.parse(saved);
        return parsed;
      }
    } catch {}
    return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
  });

  useEffect(() => {
    try {
      localStorage.setItem(sk, JSON.stringify(state));
    } catch {
      // localStorage quota exceeded — silently drop. Next write may succeed.
    }
  }, [sk, state]);

  const resetState = useCallback(() => {
    const val = typeof defaultValue === 'function' ? defaultValue() : defaultValue;
    setState(val);
  }, [defaultValue]);

  return [state, setState, resetState];
}

export default usePersistedState;
